"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WideCertificate = void 0;

var tslib_1 = require("tslib");

var Certificate_1 = tslib_1.__importDefault(require("@skbkontur/react-icons/Certificate"));

var HelpLite_1 = tslib_1.__importDefault(require("@skbkontur/react-icons/HelpLite"));

var react_1 = tslib_1.__importDefault(require("react"));

var Certificate_module_css_1 = tslib_1.__importDefault(require("./Certificate.module.css"));

var classnames_1 = tslib_1.__importDefault(require("classnames"));

var utils_1 = require("./utils");

var CabucStatusInfo_1 = require("./CabucStatusInfo");

var Plugin_1 = require("@skbkontur/plugin-js/lib/Plugin");

var configuration_1 = require("../../contexts/configuration");

var WideCertificate =
/** @class */
function (_super) {
  tslib_1.__extends(WideCertificate, _super);

  function WideCertificate() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.wrapDivRef = null;

    _this.highlightWrap = function (fieldName, fieldValue) {
      var item = _this.props.item;
      return utils_1.highlight(fieldName, fieldValue, item, Certificate_module_css_1.default.highlight);
    };

    _this.onClick = function () {
      var _a = _this.props,
          onClick = _a.onClick,
          item = _a.item;

      if (onClick) {
        onClick(item.certificate, item.storeInfo, item);
      }
    };

    _this.onDoubleClick = function () {
      var _a = _this.props,
          onDoubleClick = _a.onDoubleClick,
          item = _a.item;

      if (onDoubleClick) {
        onDoubleClick(item.certificate, item.storeInfo, item);
      }
    };

    return _this;
  }

  WideCertificate.prototype.render = function () {
    var _a, _b;

    var _this = this;

    var _c = this.context,
        pluginFullInfo = _c.pluginFullInfo,
        showInnKppPrefix = _c.showInnKppPrefix,
        CAParams = _c.CAParams;
    var _d = this.props,
        item = _d.item,
        first = _d.first,
        last = _d.last,
        selected = _d.selected;
    var certificate = item.certificate,
        storeInfo = item.storeInfo;
    var plugin = pluginFullInfo ? pluginFullInfo.plugin : undefined;

    var displayCert = function displayCert(e) {
      plugin.displayCertificate(certificate);
      e.stopPropagation();
    };

    var qualifiedIcon = certificate.isQualified() ? react_1.default.createElement("span", {
      className: Certificate_module_css_1.default.qualifiedIcon
    }, react_1.default.createElement(Certificate_1.default, null)) : '';
    var certTypeIcon = utils_1.getCertTypeIcon(certificate);
    var displayCertificateIcon = storeInfo.type !== Plugin_1.StoreType.Requisite ? react_1.default.createElement("span", {
      className: Certificate_module_css_1.default.displayCertificate,
      onClick: displayCert
    }, "\xA0", react_1.default.createElement(HelpLite_1.default, null)) : '';
    var certClassName = classnames_1.default((_a = {}, _a[Certificate_module_css_1.default.wide] = true, _a[Certificate_module_css_1.default.certificate] = true, _a[Certificate_module_css_1.default.first] = first, _a[Certificate_module_css_1.default.last] = last, _a[Certificate_module_css_1.default.selected] = selected, _a));
    var inn = this.highlightWrap('inn', certificate.inn());
    var kpp = this.highlightWrap('kpp', certificate.kpp());
    var validToClassName = classnames_1.default((_b = {}, _b[Certificate_module_css_1.default.red] = item.state !== "Active"
    /* Active */
    , _b[Certificate_module_css_1.default.validToInfo] = true, _b));
    return react_1.default.createElement("div", {
      className: certClassName,
      onClick: this.onClick,
      onDoubleClick: this.onDoubleClick,
      ref: function ref(_ref) {
        return _this.wrapDivRef = _ref;
      }
    }, qualifiedIcon, react_1.default.createElement("div", {
      className: Certificate_module_css_1.default.clrfix
    }, react_1.default.createElement("div", {
      className: Certificate_module_css_1.default.mainInfo
    }, react_1.default.createElement("div", null, react_1.default.createElement("span", {
      className: Certificate_module_css_1.default.organizationName,
      dangerouslySetInnerHTML: {
        __html: this.highlightWrap('organizationName', certificate.organizationName())
      }
    }), certTypeIcon, displayCertificateIcon), react_1.default.createElement("div", {
      className: Certificate_module_css_1.default.owner,
      dangerouslySetInnerHTML: {
        __html: this.highlightWrap('owner', certificate.owner())
      }
    })), react_1.default.createElement("div", {
      className: Certificate_module_css_1.default.details
    }, react_1.default.createElement("div", {
      className: Certificate_module_css_1.default.innKppWrap
    }, react_1.default.createElement("div", {
      className: Certificate_module_css_1.default.innKpp,
      dangerouslySetInnerHTML: {
        __html: utils_1.innKppString(inn, kpp, showInnKppPrefix)
      }
    })), react_1.default.createElement("div", {
      className: validToClassName,
      "data-tid": "wideValidTo_" + item.certificate.thumbprint()
    }, this.context.certificateProcessor.getValidToMessage(item, {
      capital: true,
      possessive: false
    })))), react_1.default.createElement("div", {
      "data-tid": "statusValidTo_" + certificate.thumbprint()
    }, item.statusInfo && react_1.default.createElement(CabucStatusInfo_1.CabucStatusInfo, {
      CAParams: CAParams,
      item: item
    })), item.staticUpdateInfo && react_1.default.createElement(CabucStatusInfo_1.StaticUpdateInfo, {
      item: item
    }));
  };

  WideCertificate.contextType = configuration_1.configurationContext;
  return WideCertificate;
}(react_1.default.Component);

exports.WideCertificate = WideCertificate;
exports.default = WideCertificate;